import Vue from 'vue';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.VUE_APP_FIREBASE_APP_ID || '',
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID || '',
};

const firebase = initializeApp(firebaseConfig);

export const analytics = getAnalytics();

Vue.prototype.$firebase = firebase;
export default firebase;
